export const common = {
  tryAgain: 'Try again',
  /** Each language names itself, in its own language — used by the language
   * switcher and every "preferred language" field. */
  languages: {
    en: 'English',
    nl: 'Nederlands',
    de: 'Deutsch',
    fr: 'Français',
    es: 'Español',
    el: 'Ελληνικά',
    it: 'Italiano',
    pt: 'Português',
    tr: 'Türkçe',
  },
} as const;
